var mp = mp || {};

// FancyBox
//-----------------------------------------------------------------
mp.fancyBox = function() {
    var $trigger = $("[data-fancybox]");

    if (!$trigger.length) {
        return;
    }
    
    $trigger.fancybox({
        infobar: false,
        buttons: [
            "close"
        ],
    });
};



// Background image holder
//-----------------------------------------------------------------
mp.backgroundHolder = function() {
    var $element = $(".background-holder");

    if (!$element.length) {
        return;
    }

    $element.each(function(){
        var $img = $(this).find('img');
        var $imageSrc = $img.attr('src');
        $img.remove();
        $(this).css('background-image', 'url('+$imageSrc+')').addClass('show');
    });
};




// Init Selectric
//-----------------------------------------------------------------
mp.selectric = function() {
    var $trigger = $('.form__select');

    if (!$trigger.length) {
        return;
    }

    $trigger.selectric({
        disableOnMobile: false,
        nativeOnMobile: true,
    });
}



// Category Filter Redirect
//----------------------------------------------------------
mp.categoryFilter = function() {
    var $element = $('.js_categoryFilter');

    if (!$element.length) {
        return;
    }

    // Watcher for click events in dropdown
    $element.on('change', function() {
        $post_link = $(this).val();
        window.location.href = $post_link;
    });
};



// Show/Hide Form groups
//----------------------------------------------------------
mp.showHideFormGroups = function() {
    var $element = $('[data-formgroup-selector]');

    if (!$element.length) {
        return;
    }

    $element.on('change', function() {
        $filter = $(this).data("formgroup-selector");

        $('[data-formgroup]').addClass("hide");
        $('[data-formgroup="'+$filter+'"]').removeClass("hide");
    });
};


// Datepicker
//-----------------------------------------------------------------
mp.datepicker = function() {
    var $element = $('.datepicker');

    if (!$element.length) {
        return;
    }

    $element.datepicker({
        language: "hr",
        todayHighlight: true,
    });
}



// Datepicker - Home Widget
//-----------------------------------------------------------------
mp.datepicekrHomeWidget = function() {
    var $element = $('.datepicker-calendar-widget');

    if (!$element.length) {
        return;
    }

    $element.on('show', function(e) {
        $date = e.date;
        getEvents($date);
    }).datepicker({
        language: "hr",
        todayHighlight: true,
        startDate: '0',
        format: 'YYYY-mm-dd 12:00:00'
    }).on('changeDate', function(e) {
        $date = e.date;
        getEvents($date);
    });
}


function getEvents($date) {
    $('.calendar__widget_events').prepend('<div class="preloader"><div class="preloader__icon"></div></div>');

    $.ajax({
        url: '/wp-json/calendar/v1/events',
        type: 'POST',
        data: {'selected_date' : $date.toDateString() },
        success: function(response) {
            console.log(response);
            $('.calendar__widget .response').html(response);
            $slider = $('.events__slider .slider');
            $slider.slick('removeSlide', null, null, true);
            $slider.html(response);
            $slider.slick('refresh');
            $('.calendar__widget_events .preloader').remove();
        },
        error : function(jqXHR) {
            //console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
        }
    });
}



$(document).ready(function (){
    mp.fancyBox();
    mp.selectric();
    mp.categoryFilter();
    mp.showHideFormGroups();
    mp.datepicker();
    mp.datepicekrHomeWidget();
    //mp.backgroundHolder();
});